import React from "react";
import { HubDialogWrapper } from "../HubDialogWrapper";
import CreateOrganizationRoleContent from "./CreateOrganizationRoleContent";

export const CreateOrganizationRole = () => {
  return (
    <HubDialogWrapper maxWidth="sm" name="create-role">
      <CreateOrganizationRoleContent />
    </HubDialogWrapper>
  );
};

export default CreateOrganizationRole;
